import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "premium-phones--body-category" }
const _hoisted_2 = { class: "premium-phones--body-category_title" }
const _hoisted_3 = { class: "h2" }
const _hoisted_4 = { class: "premium-phones--body-category_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "price" }
const _hoisted_8 = { class: "caption-medium" }
const _hoisted_9 = {
  key: 0,
  class: "premium-phones--body-category_more"
}
const _hoisted_10 = {
  key: 1,
  class: "premium-phones--body-category_empty"
}
const _hoisted_11 = { class: "caption-medium" }

import type {
  FilteredPremiumNumberType,
  PremiumCategoryView,
  PremiumNumberType,
} from "@/struct/PremiumPhoneStruct";
import {
  NumbersMapStruct,
  PremiumCategoryStruct,
} from "@/struct/PremiumStruct";
import { useI18n } from "vue-i18n";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PremiumNumbersCategory',
  props: {
    activeNumber: {},
    formatPhone: { type: Function },
    numbers: {},
    isFilled: { type: Boolean },
    searchValue: {},
    title: {},
    isLoadingListing: { type: Boolean }
  },
  emits: ["select", "show-more"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const getHighlightedPhone = (phoneId: number | string): string => {
  const rawPhone = phoneId.toString();
  const formatted = props.formatPhone(rawPhone); // Сначала делаем стандартный красивый формат (+7 xxx xxx xx xx)
  const query = props.searchValue.trim();

  if (!query) return formatted;

  const searchPattern = query.split("").join("\\s*");
  const regex = new RegExp(searchPattern, "gi");

  return formatted.replace(
    regex,
    (match) => `<span class="highlight">${match}</span>`
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numbers, (num) => {
        return (_openBlock(), _createElementBlock("div", {
          key: num.id,
          class: _normalizeClass(["premium-phones--body-category_item", { active: _ctx.activeNumber === num.id }]),
          onClick: ($event: any) => (
          emit(
            'select',
            num.id,
            Number(num.activationPrice),
            num.msisdnType.name
          )
        )
        }, [
          _createElementVNode("span", {
            class: "caption-normal",
            innerHTML: getHighlightedPhone(num.id)
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(Math.round(num.activationPrice)) + " ₽", 1)
          ])
        ], 10, _hoisted_5))
      }), 128))
    ]),
    (_ctx.numbers?.length && !_ctx.isFilled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "caption-small color-secondary uppercase bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('show-more')))
          }, _toDisplayString(_unref(t)("premium.showMore")), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.numbers?.length && !_ctx.isLoadingListing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("premium.notFound")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})